import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "JS/Redux/Store";
import { PaymentEligibleUsersService } from "JS/Services/PaymentEligibleUsers";
import { setGlobalPaymentEligibleUser } from "JS/Redux/PaymentEligibleUsers";

export const service = new PaymentEligibleUsersService();

export const usePaymentEligibleUsers = (skip: boolean = true) => {
    const [loading, setLoading] = useState(false);
    const [response, setResponse] = useState<boolean | null>(null);
    const { setGlobalPaymentEligibleUserState } =
        useGlobalPaymentEligibleUsers();

    const refetch = useCallback(() => {
        setLoading(true);
        return service
            .isPaymentEligibleUser()
            .then(async (isEligible) => {
                setGlobalPaymentEligibleUserState(isEligible);
                setResponse(isEligible);
                return isEligible;
            })
            .catch((err) => {
                return false;
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        if (!skip) refetch();
    }, [skip]);

    return {
        refetch,
        response,
        loading,
    };
};

export const useGlobalPaymentEligibleUsers = () => {
    const dispatch = useDispatch();

    const paymentEligibleUser = useAppSelector(
        (state) => state.paymentEligibleUsers,
    );

    return {
        paymentEligibleUser,
        setGlobalPaymentEligibleUserState: (payload: boolean) => {
            dispatch(setGlobalPaymentEligibleUser(payload));
        },
    };
};
